import { sortBy, toNumber } from 'lodash-es'

export const getStoreysForSeismic = (
  storeyBoundaries: PlanarModel['storey_boundaries'],
  upperMostCeilingStiffening?: SlabStiffening['stiffening'],
): number[] => {
  const storeys = sortBy(Object.keys(storeyBoundaries).map(s => toNumber(s)))
  const selectedStoreys =
    upperMostCeilingStiffening === 'NotStiffening' ? storeys.slice(0, -1) : storeys

  return [...selectedStoreys].reverse()
}
